import React, { useMemo } from 'react';

import { useTranslations } from '@lang';
import { PersonalisationMessage } from '../../PersonalisationMessage';
import { DetailTitle, DetailsRow } from '../../styled';
import type { Item } from '@common/components/ItemListingRows/Event/Event';
import moment from 'moment';
import { useIntl } from 'react-intl';

export type EventDetailsProps = {
  item: Item;
  isEditable?: boolean;
};

export const EventDetails: React.FC<EventDetailsProps> = ({ item, isEditable }) => {
  const { personalization, deliveryDetails } = item;
  const { t } = useTranslations();
  const intl = useIntl();

  const timeOfComponentRender = useMemo(() => new Date(), []);

  const basketExpiryTime = useMemo(() => {
    if (!item?.expireAt) return null;

    return moment.tz(item.expireAt, intl.timeZone || '').format('HH:mm');
  }, [item, timeOfComponentRender, intl]);

  return (
    <div>
      <PersonalisationMessage
        type="event"
        item={item}
        personalization={personalization}
        isEditable={isEditable}
      />
      {basketExpiryTime ? <em>Reserved until {basketExpiryTime}</em> : null}
      {deliveryDetails?.method === 'email' && (
        <DetailsRow>
          <div>
            <DetailTitle showOnMobile>{t('common.recipientEmail')}</DetailTitle>
            <div>{deliveryDetails.email}</div>
          </div>
        </DetailsRow>
      )}
    </div>
  );
};
